import { render, staticRenderFns } from "./ItemAutocompleteMultiselect.vue?vue&type=template&id=235857aa"
import script from "./ItemAutocompleteMultiselect.vue?vue&type=script&lang=js"
export * from "./ItemAutocompleteMultiselect.vue?vue&type=script&lang=js"
import style0 from "./ItemAutocompleteMultiselect.vue?vue&type=style&index=0&id=235857aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports